import { render, staticRenderFns } from "./ExRigging.vue?vue&type=template&id=5142fcca&scoped=true&"
import script from "./ExRigging.vue?vue&type=script&lang=js&"
export * from "./ExRigging.vue?vue&type=script&lang=js&"
import style0 from "./ExRigging.vue?vue&type=style&index=0&id=5142fcca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5142fcca",
  null
  
)

export default component.exports